export const contactInfo = {
  email: "williamlazuardi@gmail.com",
  linkedin: "https://www.linkedin.com/in/william-lazuardi",
  linkedinText: "linkedin.com/in/william-lazuardi"
}; 